<template>
  <div class="tc-model-settings">
    <div class="tc-model-settings-header">
      <el-button
        @click="back"
        class="tc-model-settings-back-button"
        type="text"
      >
        <i class="el-icon-arrow-left" /> К списку инструментов
      </el-button>
      <div class="tc-model-settings-model">
        <r-text type="caption">Модель: {{ model.name }}</r-text>
      </div>
    </div>
    <r-title type="subtitle-1" style="margin-bottom: 16px;">
      Настройки модели
    </r-title>
    <div class="tc-model-settings-content">
      <el-collapse
        class="r-collapse style-collapse"
        accordion
        v-model="activePanel"
      >
        <el-collapse-item name="profiles">
          <template slot="title">
            <r-title type="subtitle-2">Коэффициенты приведения</r-title>
          </template>
          <div class="tc-model-settings-panel">
            <profiles :controller="controller" />
          </div>
        </el-collapse-item>
        <el-collapse-item name="systems">
          <template slot="title">
            <r-title type="subtitle-2">Системы транспорта</r-title>
          </template>
          <div class="tc-model-settings-panel">
            <transport-systems :controller="controller" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import Profiles from "./profiles";
import TransportSystems from "./transport-systems";

export default {
  props: ["controller"],
  data() {
    return {
      activePanel: "profiles"
    };
  },
  components: {
    Profiles,
    TransportSystems
  },
  computed: {
    model() {
      return this.$store.state.trafficCount.model;
    }
  },
  methods: {
    back() {
      this.$store.commit("SET_TC_STATE_PROP", {
        name: "view",
        value: "mode-select"
      });
    }
  }
};
</script>

<style lang="scss">
.tc-model-settings {
  width: 440px;

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .el-button {
      padding: 0;
      font-size: 12px;
    }
  }

  &-panel {
    margin-left: 2px;
  }

  .el-collapse-item:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
